export default "recent-legendary-levels = 최근 등재된 레전드리 레벨\n\nlink-usage = 포럼 이용 가이드\nlink-quality-guideline = Hidden/Unlisted 가이드라인\n"